import React, { lazy, Suspense, useEffect } from "react";
import { CiMenuBurger, CiMenuFries } from "react-icons/ci";
import { useAppDispatch, useAppSelector } from "@/stores/hooks";
import { setCollapsed } from "@/stores/features/sideBarSlice";
import MiniProfilePreload from "./Preloads/MiniProfilePreload";
import { useCorporate } from "@/context/CorporateGroupContext";
import IsoLogo from "@/assets/isologo.avif";

const MiniProfile = lazy(() => import("./MiniProfile"));
type NavbarProps = {
  isExternal?: boolean;
};

export default function Navbar({ isExternal }: NavbarProps) {
  const authUser = useAppSelector((state) => state.auth.authUser);
  const dispatch = useAppDispatch();
  const isCollapsed = useAppSelector((state) => state.sidebarState.isCollapsed);

  const { setIsExternal } = useCorporate();

  useEffect(() => {
    if (authUser?.user?.groups) {
      const userRoles = authUser.user.groups.map((role) => role.name);
      //(userRoles);
      if (userRoles.includes("Empresa Externa")) {
        setIsExternal(true);
      } else {
        setIsExternal(false);
      }
    }
  }, [authUser]);

  return (
    <header
      className={`w-full z-20 h-12 max-h-12 bg-white transition-all border-b flex ${"justify-between"} items-center px-8 flex-shrink-0 md:sticky top-0`}
    >
      <nav
        className={`flex ${
          isExternal ? "justify-center" : "justify-between"
        } items-center w-full`}
      >
        {!isExternal && (
          <>
            {isCollapsed ? (
              <CiMenuBurger
                className="font-extrabold text-2xl cursor-pointer"
                onClick={() => dispatch(setCollapsed())}
              />
            ) : (
              <CiMenuFries
                className="font-extrabold text-2xl cursor-pointer"
                onClick={() => dispatch(setCollapsed())}
              />
            )}
          </>
        )}
        <span className="hidden md:block text-xl decoration-dashed uppercase">
          {isExternal ? (
            "Caracterización de empresas"
          ) : (
            <h2 className="flex items-center ">
              <img
                src={IsoLogo}
                alt="DPESV isologo"
                width={50}
                height={30}
                className="mx-4 w-6"
              />
              Dynamic
              <span className="pl-2 text-blue-700 font-semibold">P</span>
              <span className="text-red-600 font-semibold">e</span>
              <span className="text-green-600 font-semibold">s</span>
              <span className="text-yellow-500 font-semibold">v</span>
            </h2>
          )}
        </span>
        {!isExternal && (
          <Suspense fallback={<MiniProfilePreload />}>
            <MiniProfile
              username={`${
                authUser?.user?.first_name ? authUser.user.first_name : ""
              } ${authUser?.user?.last_name ? authUser.user.last_name : ""}`}
              cargo={authUser?.user?.groups ?? []}
              avatar={authUser?.user?.avatar ?? undefined}
            />
          </Suspense>
        )}
      </nav>
    </header>
  );
}
